import { styled, useTheme, Select } from "@mui/material";

const StyledSelect = styled(Select)<{ noPointer?: boolean }>(({ theme, noPointer }) => ({
  pointerEvents: noPointer ? "none" : "auto",
  borderRadius: "16px",
  backgroundColor: theme.palette.surface.bg,
  overflow: "hidden",
  width: "fit-content",

  ".MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    // padding: "14.5px",
    borderRadius: "16px",
    backgroundColor: theme.palette.surface.bg,
    pointerEvents: noPointer ? "none" : "auto",
    width: "100%",
    padding: "0px",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.border.dark}`,
    borderRadius: "16px",
  },

  "& .MuiSelect-icon": {
    color: theme.palette.text.secondary,
    fontSize: "24px",
  },

  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.border.dark}`,
    },
  },
}));

const BaseSelect = (props: any) => {
  const theme = useTheme();
  const { sx, paperSx, children, ...rest } = props;

  return (
    <StyledSelect
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        minWidth: "fit-content",
        padding: "14.5px",
        border:
          props.value !== props.defaultValue ? `1px solid ${theme.palette.border.light}` : "none",
        ...sx,
      }}
      MenuProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: "16px",
              backgroundColor: theme.palette.surface.bg,
              padding: "14.5px",
              ...paperSx,
            },
          },
        },
      }}
      IconComponent={undefined}
      {...rest}>
      {children}
    </StyledSelect>
  );
};

export default BaseSelect;
